import type { ReactElement } from 'react';
import { Controller, type FieldPathValue, type FieldValues, type Path, useFormContext } from 'react-hook-form';
import type { DistributiveOmit } from '../../type.utils.ts';
import GMultiAutocomplete from '../inputs/Autocomplete/GMultiAutocomplete.tsx';
import type { GMultiAutocompleteProps } from '../inputs/Autocomplete/GMultiAutocomplete.props.ts';

// biome-ignore lint/suspicious/noExplicitAny:
export type FormMultiAutocompleteProps<T extends FieldValues, N extends Path<T> = any> = DistributiveOmit<
  GMultiAutocompleteProps<FieldPathValue<T, N>[number]>,
  'value'
> & {
  name: N;
};

// biome-ignore lint/suspicious/noExplicitAny:
const FormMultiAutocomplete = <T extends FieldValues, N extends Path<T> = any>(
  props: FormMultiAutocompleteProps<T, N>
): ReactElement => {
  /* jscpd:ignore-start */
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field: { value, onChange, onBlur, ref }, fieldState, formState }): ReactElement => {
        return (
          <GMultiAutocomplete
            {...props}
            ref={ref}
            value={value || []}
            error={fieldState.error?.message ?? props.error}
            onChange={(value) => {
              props.onChange?.(value);
              onChange(value);
            }}
            onBlur={onBlur}
            disabled={(props.disabled ?? false) || formState.isSubmitting || formState.disabled}
          />
        );
      }}
    />
  );
};

export default FormMultiAutocomplete;
